export const accent = '#f90000';
export const type = '#ffffc2';
export const typeBright = '#ffff97';
export const info = '#deffe7';
export const infoBright = '#c3ffd3';
